<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <div class="container-fluid">
      <div>
        <div class="row">
          <div class="h3">公廁管理</div>
        </div>

        <div class="row" v-for="(toilet, key) in scenicToilets" :key="key">
          <div class="col-sm-12 col-md-12 bd-callout bg-white">
            <div class="h5 mb-0 font-weight-bold text-primary">
              {{ toilet.name }}
              <!-- <button
                class="btn btn-info ml-5 dropdown-toggle"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                查看即時畫面
              </button>
              <div
                class="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
                style=""
              >
                <a
                  v-for="(point, i) in toilet.camera"
                  :key="i"
                  class="dropdown-item"
                  :href="point.url"
                  >{{ point.title }}</a
                >
              </div> -->
            </div>
            <hr />
            <table class="table table-bordered table-hover h6">
              <thead class="bg-info text-white text-center">
                <tr>
                  <!-- <th scope="col">位置</th> -->
                  <th scope="col">人次</th>
                  <th scope="col">溫度</th>
                  <th scope="col">濕度</th>
                  <th scope="col">洗手乳</th>
                  <th scope="col">氨氣濃度</th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center">
                  <!-- <td>{{ toilet[toiletKeys.keyName] }}</td> -->
                  <td>{{ scenicAreaId == 3 ? toilet[toiletKeys.keyPeopleCount] : '-'}}</td>
                  <td>{{ (toilet[toiletKeys.keyTempture] <= CONST.IOT_EQUITMENT_NO_DATA) ? '-' : toilet[toiletKeys.keyTempture] }}</td>
                  <td>{{ (toilet[toiletKeys.keyHumidity] <= CONST.IOT_EQUITMENT_NO_DATA) ? '-' : toilet[toiletKeys.keyHumidity] }}</td>
                  <td :class="[toilet[toiletKeys.KeyHandDetect] < CONST.HAND_SANITIZER_CRTICAL_POINT && 
                                toilet[toiletKeys.KeyHandDetect] != CONST.IOT_EQUITMENT_NO_DATA ?
                                dangerTitleStyle : '']">
                    {{toilet[toiletKeys.KeyHandDetect] <= CONST.IOT_EQUITMENT_NO_DATA ? '-' :
                      toilet[toiletKeys.KeyHandDetect] < CONST.HAND_SANITIZER_CRTICAL_POINT ? '需補充' : '正常'}}
                  </td>
                  <td :class="[toilet[toiletKeys.KeyODOR] > CONST.ODOR_CRTICAL_POINT &&
                                toilet[toiletKeys.KeyODOR] != CONST.IOT_EQUITMENT_NO_DATA ?           
                                dangerTitleStyle : '']">
                    {{ toilet[toiletKeys.KeyODOR] <= CONST.IOT_EQUITMENT_NO_DATA ? '-' : toilet[toiletKeys.KeyODOR] }}
                  </td>
                  <!-- <td
                    v-for="(data, i) in t.senserdata"
                    :key="i"
                    :class="data.css"
                  >
                    {{ data.conent }}
                  </td> -->
                </tr>
              </tbody>
            </table>
            <p>**人次為近一小時內累計人次</p>
          </div>
          <div class="col-12 p-0" v-if="scenicAreaId == 3  && toilet.series">
            <div class="card shadow mb-4">
              <div
                class="
                  card-header
                  py-3
                  d-flex
                  flex-row
                  align-items-center
                  justify-content-between
                  bg-info
                  text-white
                "
              >
                <h6 class="h5 mb-0 font-weight-bold">今日使用人數圖</h6>
              </div>
              <div class="card-body" style="min-height: 200px">
                <div
                  class="border h3 p-2 text-center"
                  style="min-height: 300px"
                >
                  <div id="chart">
                    <apexchart
                      type="line"
                      height="200"
                      :options="chartOptions"
                      :series="toilet.series"
                    ></apexchart>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr style="width: 100%" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import moment from "moment";
import VueApexCharts from "vue-apexcharts"
import { getCountPerDay } from '../../api/elasticSearch/peopleApis'
import Utils from '../../utils/utils';
import CONST from '../../utils/const';
export default {
  name: "Home",
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      CONST: CONST,
      dangerTitleStyle: 'text-danger font-weight-bold h5',
      scenicAreaId: Utils.getScenicAreaIdFromUrlPath(),
      toiletKeys: {
        keyName: CONST.TOILET_MANAGEMENT_ITEM.NAME,
        keyPeopleCount: CONST.TOILET_MANAGEMENT_ITEM.PEOPLE_COUNT,
        keyTempture: CONST.TOILET_MANAGEMENT_ITEM.TEMPERATURE,
        keyHumidity: CONST.TOILET_MANAGEMENT_ITEM.HUMIDITY,
        KeyHandDetect: CONST.TOILET_MANAGEMENT_ITEM.HANDS_ANITIZER_DETECTORS,
        KeyODOR: CONST.TOILET_MANAGEMENT_ITEM.ODOR
      },
      scenicToilets: [],
      selectItem: null,
      selectDashoard: null,
      series: [
        {
          name: "親子廁所",
          data: [0, 0, 0, 24, 33, 26, 21, 20, 0, 0, 0, 0],
        },
        {
          name: "男廁",
          data: [0, 0, 0, 42, 13, 18, 29, 37, 0, 0, 0, 0],
        },
        {
          name: "女廁",
          data: [0, 0, 12, 29, 45, 38, 52, 47, 0, 0, 0, 0],
        },
      ],
      chartOptions: {
        chart: {
          height: 300,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2, //[5, 7, 5],
          curve: "straight",
          dashArray: [0, 8, 5],
        },
        title: {
          text: "人",
          align: "left",
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return (
              val +
              " - " +
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
              ""
            );
          },
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        xaxis: {
          categories: [
            "0-2",
            "2-4",
            "4-6",
            "6-8",
            "8-10",
            "10-12",
            "12-14",
            "14-16",
            "16-18",
            "18-20",
            "20-22",
            "22-24",
          ],
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function (val) {
                  return val + "(人)";
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val + "(人)";
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val + "(人)";
                },
              },
            },
          ],
        },
        grid: {
          borderColor: "#f1f1f1",
        },
      },
    };
  },
  computed: {
    ...mapGetters({toiletCCTVList: 'getScenicAreaToiletPeopleFlowVideoCamera'}),

  },
  watch: {
    '$route'(to, from) {
      this.scenicAreaId = Utils.getScenicAreaIdFromUrlPath()
    },

    async scenicAreaId() {
      this.getData()
    },

    toiletCCTVList() {
      const toiletGroupby = Utils.arrayGroupBy(this.toiletCCTVList, CONST.PUBLIC_PLACE_ID, CONST.TOILETS)
      this.getPeopleCountPerHour(toiletGroupby)
    }
  },
  methods: {
    async getData() {
      await this.$store.dispatch('toiletMgt/getToiletData', {id: this.scenicAreaId})
      const data = this.$store.getters['toiletMgt/getScenicToilets']({scenicAreaId: this.scenicAreaId})
      this.scenicToilets = Utils.isEmptyObject(data) ? [] : data[0][CONST.TOILET_MANAGEMENT_ITEM.TOILETS]
      await this.$store.dispatch('scenicArea/getDeviceByScenicAreaId', {id: this.scenicAreaId})
    },
    async getPeopleCountPerHour(toiletGroupby) {
      if(Utils.isEmptyObject(toiletGroupby)) {
        return 
      }

      let peopleCountResult = {}
      const st = moment().startOf('d').valueOf()
      const et = moment().valueOf()
      // const st = moment('20220629').startOf('d').valueOf()
      // const et = moment('20220629').endOf('d').valueOf()
      let filterStreamingIds = []
      for(let i = 0 ; i < toiletGroupby.length ; i++) {
        filterStreamingIds = toiletGroupby[i][CONST.TOILETS].map(t => t.streamId)
        const condition = {
          streamingIds: filterStreamingIds,
          startTime: st,
          endTime: et,
          interval: '2h',
          objectTypes: [],
          dataType: ''
        }

        peopleCountResult = await getCountPerDay(condition)
        const hours = 12 // 一天 2小時為一單位 0~24 13格
        const timestamps = Array.from({ length: hours }).map((v, i) => moment(st).add(i+i, 'h').valueOf())
        const totalCount = timestamps.map(t => {
          return peopleCountResult[t] ? peopleCountResult[t] : 0
        })

        const target = this.scenicToilets.find(t => t[CONST.PUBLIC_PLACE_ID] == toiletGroupby[i][CONST.PUBLIC_PLACE_ID]) // 一個是字串一個是數字
        if(!Utils.isEmptyObject(target)) {
          const series = {data: totalCount, name:target.name}
          series[CONST.PUBLIC_PLACE_ID] = toiletGroupby[i][CONST.PUBLIC_PLACE_ID]
          target.series = [series]
          const toielets = this.scenicToilets.slice()
          this.scenicToilets = toielets
          this.chartOptions = {...this.chartOptions} // 根據apexcharts官方文件，option與series需同時更新統計圖才會更新
        }
      }
    }
  },

  async mounted() {
    this.getData()
  }
};
</script>
